import {
  shape,
  number,
  string,
} from 'prop-types';

export default shape({
  name: string,
  statusCode: number,
  message: string,
  error: shape({
    code: number,
    code_description: string,
    error: string,
  }),
  options: shape({}),
  response: shape({}),
});
